(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bp_countdown_bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bp-countdown-bar')) {
    class BPCountdownBar extends HTMLElement {
      static parseDeadline(value) {
        const parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|([+-])(\d{2}):(\d{2}))$/.exec(value || '');
        if (!parts) return NaN;
        const [, year, month, day, hour, minute, second = '0', zone, sign, zoneHour = '0', zoneMinute = '0'] = parts;
        const y = Number(year), m = Number(month), d = Number(day), h = Number(hour), min = Number(minute), sec = Number(second);
        const zh = Number(zoneHour), zm = Number(zoneMinute);
        if (y < 2000 || m < 1 || m > 12 || d < 1 || h > 23 || min > 59 || sec > 59 || zh > 14 || zm > 59 || (zh === 14 && zm !== 0)) return NaN;
        const local = new Date(Date.UTC(y, m - 1, d, h, min, sec));
        if (local.getUTCMonth() !== m - 1 || local.getUTCDate() !== d) return NaN;
        const offset = zone === 'Z' ? 0 : (zh * 60 + zm) * (sign === '+' ? 1 : -1);
        return local.getTime() - offset * 60000;
      }

      static calendarParts(timestamp, formatter) {
        const parts = {};
        formatter.formatToParts(timestamp).forEach(part => {
          if (part.type !== 'literal') parts[part.type] = Number(part.value);
        });
        return parts;
      }

      static midnight(calendarDate, formatter) {
        let timestamp = calendarDate;
        for (let attempt = 0; attempt < 4; attempt++) {
          const parts = BPCountdownBar.calendarParts(timestamp, formatter);
          const difference = calendarDate - Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
          if (difference === 0) return timestamp;
          timestamp += difference;
        }
        return NaN;
      }

      static weeklySchedule(now, formatter) {
        const parts = BPCountdownBar.calendarParts(now, formatter);
        const day = Date.UTC(parts.year, parts.month - 1, parts.day);
        const weekday = (new Date(day).getUTCDay() + 6) % 7;
        const monday = day - weekday * 86400000;
        const weekend = weekday >= 4;
        return {
          campaign: weekend ? 'weekend' : 'midweek',
          start: BPCountdownBar.midnight(monday + (weekend ? 4 : 0) * 86400000, formatter),
          end: BPCountdownBar.midnight(monday + (weekend ? 7 : 4) * 86400000, formatter)
        };
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.editor = this.dataset.editor === 'true';
        this.weekly = this.dataset.mode === 'weekly';
        this.schedule = null;
        this.formatter = null;
        if (this.weekly) {
          try {
            this.formatter = new Intl.DateTimeFormat('en-US-u-ca-gregory-nu-latn', {
              timeZone: this.dataset.timeZone || 'America/Los_Angeles',
              year: 'numeric', month: '2-digit', day: '2-digit',
              hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
            });
          } catch (_) {}
        }
        this.end = BPCountdownBar.parseDeadline(this.dataset.end);
        this.start = this.dataset.start ? BPCountdownBar.parseDeadline(this.dataset.start) : -Infinity;
        this.valid = Number.isFinite(this.end) && !Number.isNaN(this.start) && this.start < this.end;
        this.closed = false;
        this.nodes = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-' + unit + ']'));
        if (this.nodes.some(node => !node)) return;
        this.heading = this.querySelector('[data-heading]');
        this.subtitle = this.querySelector('[data-subtitle]');
        if (this.heading) this.heading.hidden = !this.heading.textContent.trim();
        if (this.subtitle) this.subtitle.hidden = !this.subtitle.textContent.trim();
        this.onClose = () => {
          this.closed = true;
          this.hidden = true;
          clearTimeout(this.timeout);
        };
        this.onVisibility = () => {
          clearTimeout(this.timeout);
          if (!document.hidden) this.tick();
        };
        this.closeButton = this.querySelector('.bp-countdown__close');
        this.closeButton?.addEventListener('click', this.onClose);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.tick();
      }

      disconnectedCallback() {
        clearTimeout(this.timeout);
        this.closeButton?.removeEventListener('click', this.onClose);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.initialized = false;
      }

      tick() {
        clearTimeout(this.timeout);
        if (!this.isConnected || this.closed) return;
        const now = Date.now();
        if (this.weekly) {
          if (this.formatter && (!this.schedule || now < this.schedule.start || now >= this.schedule.end)) {
            this.schedule = BPCountdownBar.weeklySchedule(now, this.formatter);
            this.start = this.schedule.start;
            this.end = this.schedule.end;
            const campaign = this.schedule.campaign;
            const heading = this.dataset[campaign + 'Heading'] || '';
            const code = (this.dataset[campaign + 'Code'] || '').trim();
            const subtitle = code ? ((this.dataset.codeLabel || '') + ' ' + code).trim() : '';
            if (this.heading) {
              this.heading.textContent = heading;
              this.heading.hidden = !heading.trim();
            }
            if (this.subtitle) {
              this.subtitle.textContent = subtitle;
              this.subtitle.hidden = !subtitle;
            }
          }
          this.valid = !!this.schedule && Number.isFinite(this.start) && Number.isFinite(this.end) && this.start < this.end;
        }
        const active = this.dataset.enabled === 'true' && this.valid && now >= this.start && now < this.end;
        this.hidden = !active && !this.editor;
        const note = this.querySelector('[data-editor-note]');
        if (note) note.hidden = active;
        if (active || this.editor) {
          const remaining = active ? Math.ceil((this.end - now) / 1000) : 146197;
          const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
          values.forEach((value, index) => {
            const text = String(value).padStart(2, '0');
            if (this.nodes[index].textContent !== text) this.nodes[index].textContent = text;
          });
        }
        if (this.valid && this.dataset.enabled === 'true' && (this.weekly || now < this.end) && !document.hidden) {
          this.timeout = setTimeout(() => this.tick(), now < this.start ? Math.min(this.start - now, 60000) : 1000 - now % 1000);
        }
      }
    }
    customElements.define('bp-countdown-bar', BPCountdownBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
